import React from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";

import NodeIcon from "../../atoms/icons";
import WorkFlow from "../../organisms/workflow";
const TabFlows = ({
  tabs,
  closeTab,
  activeTab,
  toggle,
  getModels,
  onWorkflowChange,
  onSaveWorkflow
}) => {
  return (
    <div className="mt-2">
      <Nav tabs>
        {tabs.map((o, index) => (
          <NavItem key={index} className="cursor-pointer">
            <NavLink
              className={activeTab === o.id ? "active" : ""}
              onClick={e => {
                toggle(o.id);
                e.stopPropagation();
              }}
            >
              {o.slug}
              {Array.isArray(tabs) && tabs.length > 1 && (
                <span
                  className="float-right"
                  style={{ marginLeft: "5px" }}
                  onClick={e => {
                    e.stopPropagation();
                    closeTab(o.id);
                  }}
                >
                  <NodeIcon
                    Icon="MdClose"
                    Config={{
                      color: activeTab === o.id ? "#003a8e" : "#678898",
                      size: "1.4em"
                    }}
                  />
                </span>
              )}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent activeTab={activeTab}>
        {tabs.map(o => (
          <TabPane key={o.id} tabId={o.id}>
            <WorkFlow
              jdc={o.jdc}
              activeTab={activeTab}
              getModels={getModels}
              onWorkflowChange={onWorkflowChange}
              onSaveWorkflow={onSaveWorkflow}
            />
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
};
export default TabFlows;
